import { DEFAULT_LOCATIONS, CIGNADEMO, PASSWORD } from 'utils/constants';
import { selectToken, EnvTokenMap } from 'utils/selectToken';
import { IndividualLocalClientConfig } from './localConfig.types';

export const apiTokens: EnvTokenMap = {
  dev: 'Token edaa26206fcc3c2282d7eaecf09fd4092d6f4b9a',
  staging: 'Token e9f2f9efceead9255d7504619c3cf02485898790',
  prod: 'Token a6a4991d54b352bf3074e201f4b79f00911571e3',
};

const token = selectToken(apiTokens);

const cignaDemoConfig: IndividualLocalClientConfig = {
  // config name used for fetching client config from fusion
  CONFIG_NAME: 'cignademo',

  API_TOKEN: token,
  EMBOLD_CLIENT: CIGNADEMO,

  // login
  SHOW_REGION_SELECTOR: false,
  PASSWORD_REGEX: ['Cignademo26', ''],

  // other
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.Bloomfield },
  LOGIN_NETWORK_NAME: 'cignaDemoUserId',

  // content
  DISPLAY_NAME: 'Cigna',
  FORM_VARIANT: PASSWORD,
  NO_WELCOME_LINK: false,
};

export default cignaDemoConfig;
